//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClientTrusted from '@/components/client/ClientTrusted'
import AvatarDisplay from '../ui/AvatarDisplay.vue'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'SmallEmployer',
  components: {
    ClientTrusted,
    AvatarDisplay
  },
  props: {
    employer: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      avatarOptions: {
        resize: {
          width: 24,
          height: 24
        }
      }
    }
  },
  computed: {
    employerActive () {
      return !this.employer.deletedAt && this.employer.confirmed && this.employer.published
    }
  }
}
